import { useIntl } from "react-intl";

import LogoImage from "../../../../assets/image/logo.svg";
import ChatFooterAction from "../ChatFooterAction";
import LinksWeb from "./NavLinks";
import { ButtonHidden, LeftArrow, Logo, LogoButton, Nav } from "./styles";
import { NavbarViewProps } from "../types";

const WebNavBar = (props: NavbarViewProps) => {
  const intl = useIntl();

  return (
    <Nav
      id="joyride-navbar"
      className={props.collapsed ? "back-off" : ""}
      data-chat-enabled={props.chatEnabled}
      data-navbar-variant="web"
    >
      <LogoButton type="button" onClick={props.onLogoClick}>
        <Logo
          className={props.collapsed ? "back-off" : ""}
          src={LogoImage}
          alt="Logo Prática"
        />
      </LogoButton>

      <LinksWeb
        hidden={props.collapsed}
        handleHideNavbar={props.handleHideNavbar}
      />

      <ButtonHidden
        type="button"
        onClick={props.onToggleCollapsed}
        className="button-hidden"
        aria-expanded={!props.collapsed}
        aria-label={intl.formatMessage({
          id: props.collapsed
            ? "chat.expandNavigation"
            : "chat.collapseNavigation",
        })}
      >
        <LeftArrow className={props.collapsed ? "right" : "left"} />
      </ButtonHidden>

      <ChatFooterAction
        ref={props.chatActionRef}
        collapsed={props.collapsed}
        handleHideNavbar={props.handleHideNavbar}
        enabled={props.chatEnabled}
        unread={props.chatUnread}
        onOpenFromUnread={props.onChatOpenedFromUnread}
      />

      <button className="cache" type="button" onClick={props.onClearCache}>
        {intl.formatMessage({ id: "menus.Clique para atualizar" })}
      </button>
      <button className="version" type="button" onClick={props.onClearCache}>
        {intl.formatMessage({ id: "menus.Versão" })}: 1.29.0
      </button>
    </Nav>
  );
};

export default WebNavBar;
